import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { TripPurposesService } from '../../service/trip-purposes.service';

@Component({
  selector: 'app-appointment-type-mapper-add',
  templateUrl: './appointment-type-mapper-add.component.html',
  styleUrls: ['./appointment-type-mapper-add.component.css']
})
export class AppointmentTypeMapperAddComponent implements OnInit {
  configurationsForm: FormGroup;
  mapperId;
  fundingSourceList = [];
  tripPurposesList = [];
  submitted = false;

  constructor(
    private fb : FormBuilder,
    private corporateService: CorporateService,
    private tripPurposesService: TripPurposesService,
    private activatedRoute : ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.mapperId = params.get('id');
    });

    this.configurationsForm = this.fb.group({
      cooperate: ['', Validators.required],
      appointmentTypes: this.fb.array([])
    });

    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getCorporateUsers(),
      this.getTripPurposes()
    ];

    forkJoin(requests).subscribe(
      ([res1, res2]) => {

        if (res1) {
          this.fundingSourceList = res1;
        }

        if (res2) {
          this.tripPurposesList = res2.filter(purpose => purpose.type !== 'default');
        }

        if (this.mapperId) {
          this.getMapperById();
        }
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getCorporateUsers() {
    return this.corporateService.getCorporateUsers('active');
  }

  getMapperById(){
    this.tripPurposesService
      .getAppointmentTypesMapperById(this.mapperId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.configurationsForm.patchValue({
            cooperate: data.cooperate
          })
          const appointmentTypes = Object.keys(data.appointmentTypes).map(key => data.appointmentTypes[key]);
          if(appointmentTypes)
          this.addConfiguration(appointmentTypes)
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getTripPurposes() {
    return this.tripPurposesService.getTripPurposesList("active");
  }

  addConfiguration(preAppointmentTypesList?) {
    const items = this.configurationsForm.get('appointmentTypes') as FormArray;

    if (preAppointmentTypesList) {
      for (const appointmentType of preAppointmentTypesList) {
        items.push(
          this.fb.group({
            title: [appointmentType.title, Validators.required],
            appointmentType: [appointmentType.appointmentType, Validators.required]
          })
        );
      }
      return;
    }

    items.push(
      this.fb.group({
        title: ['', Validators.required],
        appointmentType: ['', Validators.required]
      })
    );
  }

  removeConfigurationItem(index: any) {
      const items =  this.configurationsForm.get('appointmentTypes')as FormArray;
      items.removeAt(index);
  }

  onSubmit() {
    this.submitted = true;
    if (this.configurationsForm.invalid || !this.configurationsForm.value.appointmentTypes.length) {
      return;
    }

    let payload;
    for (let item of this.configurationsForm.value.appointmentTypes) {
      const trimmedTitle = item.title.trim();
      const trimmedItem = { 
        ...item,
        title: trimmedTitle 
      };
      if (!payload) {
        payload = {
          cooperate: this.configurationsForm.value.cooperate,
          appointmentTypes: {
            [trimmedTitle]: trimmedItem
          }
        }
        continue;
      }

      payload = {
       ...payload,
        appointmentTypes: {
          ...payload.appointmentTypes,
          [trimmedTitle]: trimmedItem
        }
      }
    }

    this.tripPurposesService
      .saveAppointmentTypesMapper(payload, this.mapperId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.router.navigate(['/rates/appointment-types/mapper'],{state: {isMapper: true}})
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  get form(){
    return this.configurationsForm.controls;
  }

  get appointmentTypesForm() {
    return this.configurationsForm.get('appointmentTypes') as FormArray;
  }

  ngOnDestroy(): void {
  }
}
